import { formatMoneyWithSign } from "../../../utils/formatMoney";
import { client } from "../../client";

export type Rate = {
  name: string;
  value: string | null;
};

export type UnitRate = {
  id: string;
  name: string;
  metricUnit: string;
  rates: Rate[];
};

export type ChargeFrequency = {
  frequency: string;
  multiple: string;
};

export type RecurringCharge = {
  id: string;
  name: string;
  value: string;
  chargeFrequency: ChargeFrequency;
  filtered: boolean;
};
export type OneOffCharge = {
  value: string;
  filtered: boolean;
};

export type Tariff = {
  taxInclusive: boolean;
  unitRate: UnitRate | null;
  standingCharge: RecurringCharge | null;
  earlyTerminationCharge: OneOffCharge | null;
  otherRecurringCharges: RecurringCharge[];
  otherUnitRates: UnitRate[];
};

export type AgreementInfo = {
  id: string; // Product id
  fromDttm: string; // product fromDttm
  toDttm: string | null; // Product toDttm

  code: string; // productBundleDfn code, name, display
  name: string;
  display: string;
  currency: string;

  tariff: Tariff;

  createdDttm: string;
  orderDttm: string;
  number: string;
  reference: string | null;
  brokerAgent: string | null;
  purchasingGroup: string | null;
  followOn: boolean;
  terminationReceivedDt: string | null;
  terminationReason: string | null;
  contractedToDttm: string | null;
  cancelledUser: string | null;
  cancelledDttm: string | null;
};

// make sure white-spaces around "/", e.g., 'a/b" => "a / b"
export const formatMetricUnit = (text: string) =>
  text
    .split("/")
    .map((v) => v.trim())
    .join(" / ");

export const formatFrequency = (frequency: string) => {
  if (frequency === "Monthly") {
    return "month";
  } else if (frequency === "Yearly") {
    return "year";
  }
  return "day";
};

export const formatRecurringCharge = ({
  value,
  currency,
  chargeFrequency,
}: {
  value: string;
  currency: string;
  chargeFrequency: ChargeFrequency;
}) => {
  const { frequency, multiple } = chargeFrequency;
  return `${formatMoneyWithSign(currency, value, {
    transform: (v) => v / Number(multiple),
  })} / ${formatFrequency(frequency)}`;
};

export const getAccountAgreement = (
  querykey: string,
  {
    accountNumber,
    agreementId,
  }: { accountNumber: string; agreementId: string },
) => {
  return client
    .get<AgreementInfo>(`accounts/${accountNumber}/agreements/${agreementId}`)
    .then((res) => res.data);
};

export const getMeterPointAgreements = (
  querykey: string,
  {
    accountNumber,
    meterPointId,
  }: { accountNumber: string; meterPointId: string },
) => {
  return client
    .get<{ results: AgreementInfo[] }>(
      `accounts/${accountNumber}/meterpoints/${meterPointId}/agreements`,
    )
    .then((res) => res?.data?.results);
};
